import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section, SectionHeading } from "@/components/layout/Section";
import { Reveal } from "@/components/common/Reveal";
import { Applications } from "@/components/sections/Applications";
import { SERVICES_INCLUDE } from "@/content/pagesContent";

export default function Servizi() {
  return (
    <SiteLayout>
      <PageHero
        testId="servizi-page"
        micro="SERVIZI"
        title="Produzione FDM su richiesta."
        description="Dal file al pezzo reale: prototipi, componenti tecnici, ricambi, supporti, gusci e piccole serie. Un solo laboratorio per l'intero percorso, con analisi tecnica e produzione controllata."
      />

      <Applications />

      <Section id="services-include-section" tone="offwhite">
        <Reveal>
          <SectionHeading
            microLabel={SERVICES_INCLUDE.microLabel}
            title={SERVICES_INCLUDE.title}
            description={SERVICES_INCLUDE.description}
          />
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {SERVICES_INCLUDE.items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.05}>
              <div className="flex h-full gap-5 rounded-2xl border border-strato-gray-100 bg-strato-white p-6">
                <span className="strato-micro mt-1 text-strato-gray-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display text-lg font-medium text-strato-graphite">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-[1.6] text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <CtaBand />
    </SiteLayout>
  );
}
